import { graphql } from '../../../gql';

// TRIL-504: the caller's followed users for the /following people list. Self-scoped server-side.
export const GET_FOLLOWING = graphql(`
  query getFollowing($userId: String!) {
    getFollowing(userId: $userId) {
      id
      username
      displayName
      avatar
      isFollowing
    }
  }
`);
